import Error from '../model/Error';
import Kindergarten from '../dto/Kindergarten';
import axios from 'axios';

export default class KindergartenRepository {
    static findAll(federationId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/federations/${federationId}/kindergartens`)
                .then((response) => resolve(response.data.data.map((data) => Kindergarten.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static find(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}`)
                .then((response) => resolve(Kindergarten.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
